import Receipt from '../src/Receipt/index.tsx';
export default Receipt;
